import { render, staticRenderFns } from "./AgenciesTable.vue?vue&type=template&id=1506e37e&"
import script from "./AgenciesTable.vue?vue&type=script&lang=js&"
export * from "./AgenciesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports